import { render, staticRenderFns } from "./NetworkBadge.vue?vue&type=template&id=5a836d26&scoped=true&"
import script from "./NetworkBadge.vue?vue&type=script&lang=js&"
export * from "./NetworkBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a836d26",
  null
  
)

export default component.exports